<!-- ToggleCard.vue -->
<template>
    <CCard class="p-4 mt-3">
      <CRow style="text-align: left;">
        <CCol style="text-align: left;" sm="12" lg="12" @click="toggle">
          <div style="text-align: left" class="item-text">
            <CRow>
              <CCol sm="11">
                <h4 class="custom-16px-500">{{ title }}</h4>
              </CCol>
              <CCol sm="1" style="color:#171717">{{ isActive ? '-' : '+' }}</CCol>
            </CRow>
          </div>
        </CCol>
  
        <CCol sm="12" lg="12">
          <div v-show="isActive" class="item-desc mb-2 display-8">
            <slot class="custom-answer-faq font-color-171717"></slot>
          </div>
        </CCol>
      </CRow>
    </CCard>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isActive: false,
      };
    },
    props: {
      title: String,
    },
    methods: {
      toggle() {
        this.isActive = !this.isActive;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add any specific styles for your ToggleCard component */
 
  </style>
  